import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Web Development Foundations & JavaScript Essentials",
    description:
      "How the web works: client server APIs, HTML5 CSS3 & responsive design basics, Core JavaScript: variables functions loops arrays objects, ES6+ features: arrow functions promises async/await, Building problem-solving logic with JavaScript",
  },
  {
    title: "Frontend Development with React.js",
    description:
      "React architecture components & JSX, Props state & component lifecycle, Hooks: useState useEffect useRef useContext, React Router for page navigation, Integrating REST APIs with React, UI patterns reusable components & modular structure",
  },
  {
    title: "Advanced React: State Management & UI Optimization",
    description:
      "Context API vs Redux (basics), Handling global states & complex UI flows, Performance optimization: memo lazy loading suspense, Custom hooks & component architecture, Building scalable frontend apps with best practices",
  },
  {
    title: "Backend Development with Node.js",
    description:
      "Node.js runtime event-driven architecture, Creating servers using HTTP & Express, Middleware creation & routing systems, Environment variables async operations & error handling, Building clean & structured backend logic",
  },
  {
    title: "Express.js Framework & API Development",
    description:
      "RESTful API fundamentals, Building CRUD operations, Authentication & authorization (JWT), File upload cookies sessions, Securing APIs using best practices",
  },
  {
    title: "MongoDB & Database Design",
    description:
      "NoSQL vs SQL databases, MongoDB collections documents & schema design, Mongoose ODM & data modeling, Querying aggregation & indexing, Connecting backend with database securely",
  },
  {
    title: "Full-Stack Integration: Connecting React + Node + MongoDB",
    description:
      "Frontend → Backend → Database data flow, Axios & fetch API for communication, Handling forms validation & error messages, React authentication with JWT & protected routes, Building real-world MERN applications",
  },
  {
    title: "Deployment, DevOps Basics & Cloud Hosting",
    description:
      "Deploying frontend on Netlify/Vercel, Deploying backend on Render/Heroku/AWS, Environment files API keys & security, CI/CD basics for MERN apps, Monitoring logging & production optimization",
  },
  {
    title: "Advanced Features & Real-Time Functionalities",
    description:
      "Real-time communication with Socket.io, Email & OTP verification, Payment integration (Razorpay/Stripe), Role-based access control (Admin/User), Building dashboards charts & advanced UI",
  },
  {
    title: "Capstone MERN Project & Career Launchpad",
    description:
      "Build a full-stack production-ready MERN app, Backend + frontend + database + deployment, GitHub portfolio setup & documentation, Resume optimization for full-stack roles, Interview prep for MERN/Full-Stack Developer roles (DSA + Tech rounds)",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
